const WORDS = ["Dacheindeckung", "Dachsanierung", "Zink & Blech", "Dachfenster", "Sturmschaden-Notdienst", "Dachdämmung", "Schifferstadt · Speyer"];

const Star = () => (
  <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0 text-terra sm:h-9 sm:w-9" aria-hidden="true">
    <path d="M12 0l2.6 9.4L24 12l-9.4 2.6L12 24l-2.6-9.4L0 12l9.4-2.6z" fill="currentColor" />
  </svg>
);

export const Marquee = () => (
  <section aria-label="Leistungen im Überblick" className="relative overflow-hidden border-y border-white/10 bg-ink py-8 sm:py-12" data-testid="editorial-marquee">
    <div className="marquee-track flex w-max">
      {[0, 1].map((k) => (
        <div key={k} aria-hidden={k === 1} className="flex shrink-0 items-center">
          {WORDS.map((w, i) => (
            <span key={w} className="flex items-center">
              <span className={`whitespace-nowrap px-6 font-display text-5xl font-bold uppercase leading-none sm:px-10 sm:text-7xl lg:text-8xl ${i % 2 ? "text-outline" : "text-white"}`}>{w}</span>
              <Star />
            </span>
          ))}
        </div>
      ))}
    </div>
  </section>
);
